module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "dynamic-header"
  }, [(_vm.useSlider) ? _c('BeforeAfterSlider', {
    staticClass: "header-bg",
    attrs: {
      "before": _vm.content.bgImage,
      "after": _vm.content.bgImage2
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasVideo && !_vm.useSlider) ? _c('div', {
    staticClass: "header-bg",
    style: ('background-image: url(' + _vm.content.bgImage + ')')
  }) : _vm._e(), _vm._v(" "), (_vm.hasVideo && !_vm.useSlider) ? _c('div', {
    staticClass: "header-bg"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.bgWebm,
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.content.bgMp4,
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.content.bgOgg,
      "type": "video/ogg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.content.bgImage
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.content.heading))]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.content.subHeading))])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599c586a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/dynamic-petition/Header.vue
// module id = 765
// module chunks = 0